import { HelpIcon } from '@motorway/mw-highway-code';
import { VRM } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import PageHeader from '../../../common/PageHeader/PageHeader';
import { useVehicleCollectionSub } from '../../hooks/useVehicleCollectionSub';
import { vehicleCollectionStore } from '../../VehicleCollectionSubjects';

import styles from './CollectionPageHeader.scss';

export const CollectionPageHeader = () => {
  const { vehicle } = useVehicleCollectionSub();
  const openModal = () => {
    vehicleCollectionStore.setIsSaleSupportModalOpen(true);

    POST_SALE_SNOW_PLOW_EVENTS.HELP_MODAL_HEADER_OPENED();
  };

  const VrmComponent = (
    <div className={styles.pageVrmWrapper}>
      <span className={styles.vrmWrapper}>
        <VRM id="collection-page-vrm" side="front" text={vehicle?.vrm_pretty ?? ''} />
      </span>
      <span className={styles.helpIconWrapper} onClick={openModal} onKeyDown={() => {}}>
        <HelpIcon filled={false} />
      </span>
    </div>
  ) as unknown as string;

  return (
    <PageHeader
      className={styles.pageHeader}
      title={VrmComponent}
    />
  );
};
